module.exports = __webpack_public_path__ + "img/pet bowl.93246bcf.svg";